import React from 'react';
import Drawer from 'material-ui/Drawer';
import Backdrop from 'material-ui/Modal/Backdrop';

const CalendarMessagingDrawer = props => {
    const showBackdrop = props.messageDrawerOpen;

    return (
        <div>
            {showBackdrop && (
                <Backdrop
                    style={{
                        zIndex: 1
                    }}
                    open={props.messageDrawerOpen}
                    onClick={props.onClose}
                />
            )}
            <Drawer
                variant="persistent"
                className="h-drawer"
                anchor="right"
                onClose={props.onClose}
                open={props.messageDrawerOpen}
            >
                <div style={{ width: 400 }} />
                <iframe
                    title="Messaging"
                    src={props.path}
                    frameBorder="0"
                    style={{
                        width: 390,
                        height: '100vh'
                    }}
                    allowFullScreen
                />
            </Drawer>
        </div>
    );
};

export default CalendarMessagingDrawer;
